import React, { Fragment, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Dropdown from "react-bootstrap/Dropdown";
import AxisSpinner from "./AxisSpinner";

const DropDownWardSelection = ({
  defaultValue,
  onSelected,
  trust,
  facility,
}) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(true);
  const [wards, setWards] = useState([]);
  const [selected, setSelected] = useState(null);
  const [searchTerm, setSearchTerm] = useState(null);

  useEffect(() => {
    getWards();
  }, [searchTerm, trust, facility]);

  useEffect(() => {
    if (defaultValue === null || defaultValue === undefined) return;

    setSelected(defaultValue);
  }, [defaultValue]);

  const getWards = async () => {
    try {
      setLoading(true);

      var params = {};
      if (trust !== null && trust !== undefined) {
        params["trust_id"] = trust?.id;
      }
      if (facility !== null && facility !== undefined) {
        params["facility_id"] = facility?.id;
      }
      if (searchTerm !== null && searchTerm !== "") {
        params["search"] = searchTerm;
      }
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: params,
      };

      const response = await authAxios().post(
        "/api/backoffice/wards/all",
        null,
        config,
      );
      setWards(response.data);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error catch");
      console.log(error);
      console.log(error.stack);
    }
  };

  const selectWard = (ward) => {
    setSelected(ward);
    onSelected(ward);
  };

  const SpinnerOrData = (loading) => {
    if (loading) return <AxisSpinner loading={loading} />;
    return (
      <Fragment>
        {wards.map((ward) => (
          <Dropdown.Item key={ward?.id} onClick={() => selectWard(ward)}>
            {ward?.identifier}
          </Dropdown.Item>
        ))}
      </Fragment>
    );
  };

  return (
    <div>
      <Dropdown>
        <Dropdown.Toggle className={"shift-table-dropdown"} id="dropdown-basic">
          {selected !== null ? selected?.identifier : "Wards"}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <input
            type="text"
            placeholder="Search..."
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              margin: "8px 10px",
              width: "calc(100% - 20px)",
              borderRadius: "5px",
            }}
          />

          {selected !== null ? (
            <Dropdown.Item onClick={() => selectWard(null)}>
              X Remove Selection
            </Dropdown.Item>
          ) : null}

          {SpinnerOrData(loading)}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default DropDownWardSelection;
